<template>
  <div class="banner">
    <div class="header">
      <div class="container">
        <div class="con">
          <!-- <p class="one">{{titleone}}</p> -->
          <p class="two">
            <!-- 河南诚建工程投资担保有限责任公司成立于2006年，注册资金三亿元人民币，是我省成立的首家专业工程担保公司，也是通过省住建厅备案的首家工程担保公司。 -->
          </p>
          <!-- <p class="two">{{titletwo}}</p> -->
          <p class="two">
            <!-- 公司以“诚实守信、服务建设”为宗旨，汇集专业的工程、财务、法律队伍，以经营的专业化和人才的专业化为基础，发挥专业化的服务优势，具备较高的同行业
            竞争优势，已累计为上万个建设工程项目提供工程担保服务。公司立足工程担保，创立“河南诚建”百年基业。 -->
          </p>
          <!-- <button class="button" v-on:click="about">{{titlebutton}}</button> -->
        </div>
      </div>
      <!-- <div class="" v-show="isColRight"> -->
      <Carousel autoplay :autoplay-speed="10000" loop v-if="banners&&banners.length">
        <CarouselItem v-for="(banner,idx) in banners" :key="idx">
          <img :src="banner" width="100%" height="700px" />
        </CarouselItem>
        <!-- <CarouselItem>
          <img :src="imgUrl" width="100%" height="500px" />
        </CarouselItem> -->
        <!-- <CarouselItem>
          <img :src="imgUrl" width="100%" height="500px" />
        </CarouselItem> -->
      </Carousel>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      imgUrl: '',
      banners: [],
      titleone: '',
      titletwo: '',
      titlebutton: ''
    }
  },
  mounted () {
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        if (response.data.INDEX_BANNERS && response.data.INDEX_BANNERS instanceof Array) {
          this.banners = response.data.INDEX_BANNERS
          this.titleone = response.data.BANNER_ONE
          this.titletwo = response.data.BANNER_TWO
          this.titlebutton = response.data.BANNER_BUTTON
          // console.log(this.banners)
        }
        // console.log(this.banners)
      })
    // console.log(this.imgUrl)
    // let that = this
    // that.imgUrl = require('../.././static/photo/1.jpg')
    // console.log('11')
  },
  methods: {
    about: function (event) {
      window.location.href = '#/join'
    // initBanners () {
    //   axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
    //     .then(response => {
    //       if (response.data.INDEX_BANNERS instanceof Array && response.data.INDEX_BANNERS instanceof Array) {
    //         this.banners = response.data.INDEX_BANNERS
    //       }
    //       console.log(this.banners)
    //     })
    }
  }
}

</script>

<style lang="less" scoped>
@import url('../../static/less/less.css');
// @keyframes FadeUp{
//   from {bottom: -30px;}
//   to {bottom: 0px;}
// }
.company {
  color: #fdfffc;
  float: left;
}
.banner {
  // min-width: 1200px;
  // height: 368px;
  .con {
    position: absolute;
    width: 100%;
    padding-top: 145px;
    text-align: center;
    .one {
      font-size: 50px;
      padding-top: 30px;
      text-align: center;
      color: #fdfffc;
      z-index: 3;
    }
    .two {
      padding: 10px 0 10px 0;
      font-size: 18px;
      text-align: center;
      color: #fdfffc;
      // z-index: 3;
    }
    .button {
      position: relative;
      animation-name: FadeUp;
      animation-duration: 1.5s;
      background-color: #3B9FF2;
      width: 120px;
      height: 35px;
      margin-top: 20px;
      border: none;
      cursor: pointer;
      color: #fdfffc;
      border: solid 1px #fdfffc;
      border-radius: 3px;
      // transition: all 0.3s;
      // z-index: 3;
    }
    .button:hover {
      background: #fdfffc;
      color: #3B9FF2;
      transition: all .3s ease-in-out;
    }
  }
}
.header {
  display: block;
  width: 100%;
  .container {
    position: absolute;
    margin: 0 10%;
    z-index: 5;
    width: 80%;
  }
}
.nav {
  height: auto;
  position: relative;
  .logo {
    position: relative;
    float: left;
    text-align: center;
    padding-top: 10px;
  }
    // .tel {
    //   float: right;
    //   // width: 50%;
    //   padding-top: 20px;
    //   span {
    //     display: block;
    //   }
  &-row {
    float: right;
    margin: 0 auto;
    padding-top: 30px;
    .float-right {
      float: right;
      padding: 0 10px 0 0;
      font-size: 16px;
    }
    .clearfix {
      margin: 0px;
      li {
        display: inline-block;
        margin: 0 10px;
      }
      .active {
        display: inline-flex;
        text-align: center;
        a {
          color: #fdfffc;
          transition: 0.6s;
          display: block;
          text-align: center;
          position: relative;
        }
        a:hover {
          background-color: #2973c3;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue